import { render, staticRenderFns } from "../../assets/templates/MicroService/MicroServiceManager.html?vue&type=template&id=4bd1b819&scoped=true&"
import script from "../../assets/scripts/MicroService/MicroServiceManager.js?vue&type=script&lang=js&"
export * from "../../assets/scripts/MicroService/MicroServiceManager.js?vue&type=script&lang=js&"
import style0 from "../../assets/scss/microServiceManager.scss?vue&type=style&index=0&id=4bd1b819&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd1b819",
  null
  
)

export default component.exports